import i18n from "i18next";

const fallbackLanguage = () => {
  const { fallbackLng } = i18n.options;

  return Array.isArray(fallbackLng) ? fallbackLng[0] : fallbackLng;
};

export const languagePrefix = () => {
  const fallback = fallbackLanguage();
  const language = i18n.resolvedLanguage || i18n.language || fallback;

  return language && language !== fallback ? `/${language}` : "";
};
